/**
 * @author       mike.zarra@zumper.com (Mike Zarra)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  trackHomepageImpressionEvent
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { HOMEPAGE_IMPRESSION, event } from '@zcode-ui/web-zumper-integrations'
import { PAGE_NAMES } from '@zcode/mixpanel'
import type { GetState } from '@zcode/state-type'
import type { Dispatch } from 'redux'
import { mixpanelViewPage } from '../../mixpanel/thunks/mixpanelViewPage'

export const trackHomepageImpressionEvent = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState()
  const user = getUser(state)
  dispatch(event({ name: HOMEPAGE_IMPRESSION, user }))
  dispatch(mixpanelViewPage({ pageName: PAGE_NAMES.HOMEPAGE }))
}
